import React, { useState } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import { getPageClass } from "../utils"

import "./layout.scss"

const defaultContext = {
}
const globalContext = React.createContext( defaultContext )

export const Layout = ( { children, location, pageContext, ...props } ) => {

  const intl = pageContext.intl
  const url = location.pathname + location.hash
  const [ menuOpened, toggleMenu ] = useState( false )
  const [ pathname, setPathname ] = useState( url )
  const title = intl.messages[ "metadata.title" ]
  const desc = intl.messages[ "metadata.description" ]
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
            domain
            shareImage
          }
        }
      }
    `
  )
  const shareImage = site.siteMetadata.domain + site.siteMetadata.shareImage


  if( pathname !== url ) {
    setPathname( url )
    toggleMenu( false )
  }

  return (
    <>
      <globalContext.Provider>
        <Helmet htmlAttributes={{ lang: pageContext.intl.language }} >
          <title>{ title }</title>
          <meta name="description" content={ desc } />
          <meta name="image" content={ shareImage } />
          <meta property="og:title" content={ title } />
          <meta property="og:description" content={ desc } />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={ site.siteMetadata.url } />
          <meta property="og:image" content={ shareImage } />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:creator" content={ site.siteMetadata.author } />
          <meta name="twitter:title" content={ title } />
          <meta name="twitter:description" content={ desc } />
          <meta name="twitter:image" content={ shareImage } />

          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-145926657-1"></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'UA-145926657-1');
            `}
          </script>
        </Helmet>
        <div className={ getPageClass( location.pathname, menuOpened ) }>
          <Header pathname={ location.pathname } menuOpened={ menuOpened } toggleMenu={ toggleMenu }/>
          { children }
          <Footer pathname={ location.pathname } />
        </div>
      </globalContext.Provider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
